import React, { Component} from 'react';
import CampaignCard from './CampaignCard'
import Slider from 'react-slick';
import styled from 'styled-components';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';



const SliderWrapper = styled.div`
padding-bottom: 30px;
`


const CampaignSlider = ({campaigns}) => {
  const settings = {
    dots: true,
    infinite: true,
    autoplaySpeed: 5000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    arrows: true,
    autoplay: true
  };
  if(campaigns.edges) {
    return (
      <SliderWrapper>
        <Slider {...settings}>
          {campaigns.edges.map(campaign => {
            return <CampaignCard key={campaign.node.id} {...campaign.node}  />
          })}
        </Slider>
      </SliderWrapper>
    );
  } else {
    return <div></div>
  }

};
export default  CampaignSlider;



// WEBPACK FOOTER //
// ./src/components/Campaign/CampaignSlider.js